// This file holds switches, that are prepared for future enabling of features that need deployment coordination.

// This will be flipped to true after the client with the normalized password support is prominently used.
export const USE_PASSWORD_NORMALIZATION = true;
